import { render, staticRenderFns } from "./FundsDiversificationFund.vue?vue&type=template&id=55cda5cf&scoped=true"
import script from "./FundsDiversificationFund.vue?vue&type=script&lang=js"
export * from "./FundsDiversificationFund.vue?vue&type=script&lang=js"
import style0 from "./FundsDiversificationFund.vue?vue&type=style&index=0&id=55cda5cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cda5cf",
  null
  
)

export default component.exports